import { useState } from 'react';
import { DropDownButton, DropdownItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { IconName } from '@optimus-web/icons';
import { TextKey } from '@mews-commander/enums';
import { EditDialog } from '../../enums';
import { ReleaseAllDialog } from '../Dialogs/ReleaseAllDialog';
import { ReleaseDateDialog } from '../Dialogs/ReleaseDateDialog/ReleaseDateDialog';

interface AvailabilityBlockDatesMenuProps {
    availabilityBlockId: string;
    isEditingAvailability: boolean;
    isReleasable: boolean;
}

export const AvailabilityBlockDatesMenu: React.FC<AvailabilityBlockDatesMenuProps> = ({
    availabilityBlockId,
    isEditingAvailability,
    isReleasable,
}) => {
    const [dialog, setDialog] = useState<EditDialog.ReleaseAll | EditDialog.ReleasedDateForm | null>(null);

    const showReleaseAll = isReleasable && !isEditingAvailability;

    const openReleaseDateForm = () => {
        setDialog(EditDialog.ReleasedDateForm);
    };

    const openRelaseAllDialog = () => {
        setDialog(EditDialog.ReleaseAll);
    };

    const closeDialog = () => {
        setDialog(null);
    };

    const dialogProps = {
        availabilityBlockId,
        onClose: closeDialog,
    };

    return (
        <>
            <DropDownButton icon={IconName.More} variant="ghost" size="medium">
                <DropdownItem
                    label={<LocalizedText textKey={TextKey.Edit} />}
                    onClick={openReleaseDateForm}
                    data-test-edit-release-date
                />
                {showReleaseAll && (
                    <DropdownItem
                        label={<LocalizedText textKey={TextKey.ReleaseAll} />}
                        onClick={openRelaseAllDialog}
                        data-test-release-all
                    />
                )}
            </DropDownButton>

            {dialog === EditDialog.ReleaseAll && <ReleaseAllDialog {...dialogProps} />}

            {dialog === EditDialog.ReleasedDateForm && <ReleaseDateDialog {...dialogProps} />}
        </>
    );
};
